import React, { useEffect, useState } from 'react'
import { Table } from '../../components/Table/Table'
import {  left_arrow, no_image,  view_icon,  } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import {  useLazyReceptionListViewQuery } from '../redux/api/api';

const ReceptionView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [popup, setPopup] = useState(false);
    const [list, setList] = useState([]);
    const [type, setType] = useState();
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [mobile, setMobile] = useState();
    const [secMobile, setSecMobile] = useState();
    const [gender, setGender] = useState();
    const [address, setAddress] = useState();
    const [ownerName, setOwnerName] = useState();
    const [profileImage, setProfileImage] = useState();

    const id = location?.state?.id;
    console.log("id", id);

    const [receptionViewApi] = useLazyReceptionListViewQuery();

    const receptionListView = (id) => {
        receptionViewApi(id)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                setList(res?.data?.properties)
                setName(res?.data?.name);
                setEmail(res?.data?.email);
                setMobile(res?.data?.mobile);
                setAddress(res?.data?.address);
                setGender(res?.data?.gender);
                setSecMobile(res?.data?.secondary_number);
                setOwnerName(res?.data?.owner?.name);
                setProfileImage(res?.data?.image_url ? res?.data?.image_url : no_image);
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    useEffect(() => {
        if (id) {
            receptionListView(id);
        }
    }, []);



    const [active, setActive] = useState('Profile');



    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row.index + 1}</p>;
                },
            },
            {
                Header: "Property name",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate("/property-view", { state: { data: row.original } })}>{value}</p></div>
                },
            },
            {
                Header: "Owner ID",
                accessor: "owner",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate("/owner-view", { state: { type: "view", id: row.original.owner?.id } })}>{value?.owner_id}</p></div>
                },
            },
            {
                Header: "Owner Name",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate("/owner-view", { state: { type: "view", id: row.original.owner?.id } })}>{row?.original?.owner?.name}</p></div>
                },
            },
            {
                Header: "Location",
                accessor: "city",
                Cell: ({ value, row }) => {
                    return <p>{value?.name}</p>;
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                <button
                                    onClick={() => { setPopup(true); setType("add") }}
                                    className="cust-btn "
                                >
                                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                </button>
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    Receptionist View
                </h2>
                <div onClick={() => { setPopup(true) }} className='d-flex gap-2'>
                    <img src={profileImage} onChange={(e) => setProfileImage(e.target.value)} className="profile-img " />
                </div>
            </div>
            {popup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <div className="d-flex ac-je pointer" onClick={() => setPopup(false)}>
                            <CancelIcon />
                        </div>
                        <div className='profile-img-pop' >
                            <img style={{ width: "300px", height: "300px" }}
                                src={profileImage}
                                alt=""
                                className="w-100 mt-3"
                            />
                        </div>
                    </div>
                </div>
            )}
            <div className='d-flex ac-js gap-3' style={{ cursor: 'pointer' }}>
                <div
                    className={`${active === 'Profile' ? 'line-btm' : ''}`} // Apply 'line-btm' only if active
                    onClick={() => setActive('Profile')}
                >
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-18 fs-xxl-20 mt-2 mb-0">Receptionist</p>
                </div>
                <div
                    className={`${active === 'Booking' ? 'line-btm' : ''}`} // Apply 'line-btm' only if active
                    onClick={() => setActive('Booking')}
                >
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-18 fs-xxl-20 mt-2 mb-0">Property</p>
                </div>
            </div>


            <div className='d-flex ac-js gap-2 mt-3'
                onClick={() => navigate(-1)}
            >
                <img src={left_arrow} className='leftArrow mb-3' />
                <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
            </div>

            {active == "Booking" ? (
                <div>
                    <Table columns={columns} data={list} />
                </div>
            ) :
                <div className="">
                    <div className='d-flex gap-5'>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Name
                            </h4>
                            <input type="text" readOnly value={name} onChange={(e) => setName(e.target.value)} className="input-pop ps-2 w-100" placeholder="Name" />
                        </div>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Email
                            </h4>
                            <input type="email" readOnly value={email} onChange={(e) => setEmail(e.target.value)} className="input-pop ps-2 w-100" placeholder="Owner Name" />
                        </div>
                    </div>
                    <div className='d-flex gap-5'>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Mobile Number
                            </h4>
                            <input type="number" readOnly value={mobile} onChange={(e) => setMobile(e.target.value)} className="input-pop ps-2 w-100" placeholder="Mobile Number" />
                        </div>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Secondary Mobile Number
                            </h4>
                            <input type="number" readOnly value={secMobile} onChange={(e) => setSecMobile(e.target.value)} className="input-pop ps-2 w-100" placeholder="Secondary Mobile Number" />
                        </div>
                    </div>
                    <div className='d-flex gap-5'>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Gender
                            </h4>
                            <input type="text" readOnly value={gender == 1 ? 'Male' : 'Female'} onChange={(e) => setGender(e.target.value)} className="input-pop ps-2 w-100" placeholder="Gender" />
                          
                        </div>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Owner Name
                            </h4>
                            <input type="text" readOnly value={ownerName} onChange={(e) => setOwnerName(e.target.value)} className="input-pop ps-2 w-100" placeholder="Owner Name" />
                        </div>
                    </div>
                    <div>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Address
                            </h4>
                            <textarea type="text" readOnly value={address} onChange={(e) => setAddress(e.target.value)} className="input-pop ps-2 w-100 h-100" placeholder="Address" />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default ReceptionView